/**
 * Founding Beta — silent telemetry helper.
 *
 * Use trackEvent('parent_viewed_radar', { target_id, once: true }) anywhere
 * inside an authenticated component. Non-whitelisted events are silently
 * rejected by the backend; we never throw to the UI.
 */
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const tokenKeys = ['meybra_token', 'club_token', 'parent_token', 'coach_token'];
const getToken = () => {
  for (const k of tokenKeys) {
    const t = typeof window !== 'undefined' && window.localStorage?.getItem(k);
    if (t) return t;
  }
  return null;
};

export async function trackEvent(event, options = {}) {
  const token = getToken();
  if (!token) return; // silent — user not logged in
  try {
    await axios.post(
      `${API}/events/track`,
      {
        event,
        target_id: options.target_id || null,
        target_type: options.target_type || null,
        metadata: options.metadata || null,
        once: !!options.once,
      },
      { headers: { Authorization: `Bearer ${token}` } }
    );
  } catch (e) {
    // Telemetry must never break the UX.
  }
}
